﻿'use strict';

/*jslint bitwise: true */
angular.module('ntmApp')
  .filter('minutesFormat', function () {

      return function (input, formatType) {
          
          if (angular.isNumber(input)) {

              var time = parseFloat(input);
              var hours = (time / 60) >> 0;
              var minutes = parseInt((time % 60).toFixed());

              if (minutes === 60) {
                  hours += 1;
                  minutes = 0;
              }

              var hoursFormat = 'hr';
              var minutesFormat = 'min';

              if (formatType) {
                  switch (formatType) {
                      case 'shortFormat':
                          hoursFormat = 'h';
                          minutesFormat = 'm';
                          break;
                      case 'longFormat':
                          hoursFormat = 'hours';
                          minutesFormat = 'minutes';
                          break;
                  }
              }

              return '{0} {2} {1} {3}'.format(hours, Math.abs(minutes), hoursFormat, minutesFormat);
          }

          return input;
      };
  });